<ng-container *transloco="let t">
  <div class="error-container">
    <div class="error-absolute">
      <h1 class="heading-size-2">{{ t('error_page_title') }}</h1>
      <div [innerHTML]="t('error_page_body')"></div>
    </div>
  </div>
</ng-container>
